import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Condition grades with descriptions
export const CONDITIONS = {
  'M': { label: 'Mint', description: 'Perfect, unplayed condition' },
  'NM': { label: 'Near Mint', description: 'Nearly perfect, minimal signs of handling' },
  'VG+': { label: 'Very Good Plus', description: 'Shows some signs of play but well cared for' },
  'VG': { label: 'Very Good', description: 'Surface noise evident, light scratches' },
  'G+': { label: 'Good Plus', description: 'Plays through without skipping' },
  'G': { label: 'Good', description: 'Significant wear, but still playable' },
  'F': { label: 'Fair', description: 'Heavy wear, may skip' },
  'P': { label: 'Poor', description: 'Barely playable' },
};

export const CONDITION_OPTIONS = Object.entries(CONDITIONS).map(([value, { label }]) => ({
  value,
  label: `${value} (${label})`,
}));

// Format currency with proper handling
export function formatCurrency(amount, currency = 'USD') {
  if (amount === null || amount === undefined) return null;
  if (!currency) currency = 'USD';
  
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

// Parse Discogs title (usually "Artist - Title")
export function parseDiscogsTitle(title) {
  if (!title) return { artist: '', title: '' };
  const parts = title.split(' - ');
  if (parts.length >= 2) {
    return {
      artist: parts[0].trim(),
      title: parts.slice(1).join(' - ').trim(),
    };
  }
  return { artist: '', title: title };
}
